<template>
  <div
    v-bind:style="showModalStow ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Crear arrumaje</h5>
          <button
            @click="close(false)"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="send()">
            <div class="form-group">
              <date-picker
                v-model="date"
                lang="es"
                type="datetime"
                format="DD/MM/YYYY HH:mm"
                required
                :time-picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
              ></date-picker>
            </div>
            <div class="form-group">
              <input type="submit" class="btn btn-primary" value="Enviar">
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import moment from "moment";
export default {
  props: ["id", "showModalStow"],
  data() {
    return {
      date: ""
    };
  },
  methods: {
    send() {
      let data = {
        requeriment_id: this.id,
        date: moment(this.date).format("YYYY-MM-DD HH:mm:ss")
      };

      api.post("/requeriments", data).then(response => {
        if (response.success) {
          this.hasStow = true;
          this.$toastr.success(`Arrumaje creado`, "Requerimiento", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          this.$emit("close", { has_stow: this.hasStow });
        }
      });
    },
    close(hasStow) {
      this.$emit("close", hasStow);
    }
  }
};
</script>
